export default class ClientLandman {
    clientAddress?: string;
    clientAddress2?: string;
    businessEmail?: string;
    title?: string;
    salutation?: string;
    clientZipCode?: number;
    homeAddress?: number;
    homeAddress2?: number;
    homeZipCode?: number;
    homeState?: string;
    homeCity?: string;
    cellPhone?: string;
    homeEmail?: string;
    personalCellPhone?: string;
    officePhone?: string;
    officePhoneExt?: string;
    lastName: string;
    firstName: string;
    id: number;
    clientNumber: number;
    number: number;
    clientName: string;
    clientCity: string;
    clientState: string;
    fax: string;
    whereNow: string;
    comments?: string;
    certifications?: string;
    status?: boolean;
}



// WEBPACK FOOTER //
// ./src/models/ClientLandman.ts